import { httpsCallable } from 'firebase/functions';
import { functions } from 'services/Firebase';

type Args = {
  artistId: string;
  reason: string;
};

export const disableUser = async (args: Args) => {
  const req = httpsCallable(functions, 'disableUser');
  return await req(args);
};

export type DisableUserRequestData = Args;
